import { useDispatch } from 'react-redux';

import { TextArea } from '@opendoor/bricks-next';

import { trackAnswerChange } from 'src/components/fields/trackAnswerChange';
import { getErrorMessage } from 'src/components/flowPage/twoColumn/ErrorMessages';
import { MultiLineTextQuestion } from 'src/lib/flow/FlowQuestion';
import { checkValidation } from 'src/lib/flow/validation';
import { changeAnswers } from 'src/store/sellerInput';

export type TextAreaProps = {
  question: MultiLineTextQuestion;
  value?: string;
  showValidation?: boolean;
};

const TextAreaInput: React.FC<TextAreaProps> = ({ question, value, showValidation }) => {
  const dispatch = useDispatch();
  const { label, key, placeholder, helperText } = question;

  let hasError = false;
  let errorText: string | undefined;
  if (showValidation) {
    const validationResult = checkValidation(question, value);
    if (!validationResult.isValid) {
      errorText = getErrorMessage(validationResult);
      hasError = true;
    }
  }

  return (
    <TextArea
      title={label || ''}
      supportText={helperText}
      errorText={errorText}
      id={key}
      placeholder={placeholder}
      invalid={hasError}
      name={key}
      onChangeText={(text: string) => {
        const answer = text ?? null;
        dispatch(changeAnswers([{ key, answer }]));
      }}
      onBlur={() => trackAnswerChange(key, value)}
      value={value ?? ''}
      maxLength={230}
      size="large"
      inputMode="text"
    />
  );
};

export default TextAreaInput;
